<template>
  <div>
    <div class="flex items-center">
      <input
        v-bind="$attrs"
        v-model="checked"
        :id="id"
        :value="val"
        @change="$emit('input', checkedProxy)"
        class="h-6 w-6 rounded-md border-gray-400 border-1 text-gray-800 hover:border-gray-800 focus:border-navy-400 focus:ring-0 disabled:opacity-40"
        type="checkbox"
      />
      <sg-label v-if="$slots.default" class="ml-2.5" :for="id">
        <slot />
      </sg-label>
    </div>
    <sg-input-error :error="error" />
  </div>
</template>

<script>
export default {
  props: {
    error: {
      type: String,
      default: null,
    },
    id: {
      type: String,
      default: null,
    },
    val: {
      default: null,
    },
    value: {
      default: null,
    },
  },

  computed: {
    checked: {
      get() {
        return this.value;
      },
      set(val) {
        this.checkedProxy = val;
      },
    },
  },

  data() {
    return {
      checkedProxy: false,
    };
  },

  inheritAttrs: false,
};
</script>
